"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHelpOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 27a1.5 1.5 0 101.5 1.49A1.48 1.48 0 0016 27zM16 2c-3.9 0-6.4 1.43-7.44 4.25A10.39 10.39 0 008 9.85h2a8.67 8.67 0 01.43-2.91C10.9 5.68 12 4 16 4c4.21 0 6 1.74 6 5.78s-1.5 5-3.23 6.22S15 18.63 15 22.9V24h2v-1.1c0-3.23 1.29-4.12 2.91-5.25C21.73 16.38 24 14.81 24 9.78S21.31 2 16 2z" })));
}
exports.default = SvgHelpOutline;
//# sourceMappingURL=HelpOutline.js.map